import { defineStore } from 'pinia'

import type { DisciplineTasksStore } from './interfaces'

import { emptyTutorTasksFilters } from '@helpers/tutor-tasks-query'

import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineTasksStore = defineStore('discipline-tasks', {
  state: (): DisciplineTasksStore => ({
    loading: false,
    exporting: false,
    tasks: [],
    meta: null,
    filters: emptyTutorTasksFilters(),
    currentPage: 1,
    perPage: 25,
    activeModal: null,
    activeTask: null,
  }),
  actions,
  getters,
})
